import { Link } from "react-router-dom";
import { useAuth } from "@/App";

/**
 * Barre d'onglets d'un projet.
 *
 * Elle etait recopiee dans chacune des sept pages, et les copies avaient
 * derive : la fiche projet en affichait sept, le chat et le CDC trois,
 * les acces cinq. Passer sur le chat donnait donc l'impression que les
 * onglets disparaissaient. Une seule source desormais.
 */
const ONGLETS = [
  { cle: "apercu", libelle: "Aperçu", chemin: "" },
  // Devis et cahier des charges réunis ; l'avancement se suit dans la feuille de route.
  { cle: "cdc", libelle: "CDC", chemin: "/cdc", modes: ["cdc", "commercial"] },
  // Chat Claude et Équipe IA réunis : un onglet, deux modes (voir MODES_IA).
  { cle: "ia", libelle: "IA du projet", chemin: "/chat", modes: ["chat", "agents"] },
  { cle: "activite", libelle: "Activité IA & mémoire", chemin: "/activite" },
  { cle: "roadmap", libelle: "Feuille de route", chemin: "/roadmap" },
  { cle: "git", libelle: "Git", chemin: "/git" },
  { cle: "acces", libelle: "Accès", chemin: "/access" },
  { cle: "fichiers", libelle: "Fichiers", chemin: "/files" },
  { cle: "serveur", libelle: "Serveur", chemin: "/server" },
];

const MODES_IA = [
  { cle: "chat", libelle: "Rapide", aide: "Claude seul, direct : question, correction, petite modification", chemin: "/chat" },
  { cle: "agents", libelle: "Équipe", aide: "Architecte, Développeur, Réviseur, Testeur : fonctionnalité complète selon le CDC", chemin: "/agents" },
];

const MODES_CDC = [
  { cle: "cdc", libelle: "Cahier des charges", aide: "Le contenu, fonctionnalité par fonctionnalité : cocher une case fait avancer la feuille de route", chemin: "/cdc" },
  { cle: "commercial", libelle: "Devis & PDF client", aide: "Le document envoyé au client : devis puis cahier des charges", chemin: "/commercial" },
];

export default function ProjectTabs({ projectId, actif }) {
  const { user } = useAuth();
  const ongletsStagiaire = ["apercu", "cdc", "ia", "activite", "roadmap", "git", "acces"];
  if (user?.can_develop) ongletsStagiaire.push("fichiers");
  if (user?.can_deploy) ongletsStagiaire.push("serveur");
  const ongletsVisibles = user?.role === "intern"
    ? ONGLETS.filter((o) => ongletsStagiaire.includes(o.cle))
    : ONGLETS;
  const ongletActif = ONGLETS.find((o) => o.cle === actif || o.modes?.includes(actif))?.cle;
  const modes = MODES_IA.some((m) => m.cle === actif)
    ? (user?.role === "intern" && !user?.can_develop ? MODES_IA.filter((m) => m.cle === "chat") : MODES_IA)
    : MODES_CDC.some((m) => m.cle === actif)
      ? (user?.role === "intern" ? MODES_CDC.filter((m) => m.cle === "cdc") : MODES_CDC)
      : null;
  const modeIA = modes?.find((m) => m.cle === actif);
  return (
    <>
    <div className={`${modeIA ? "mb-3" : "mb-5"} flex max-w-full flex-nowrap gap-1 overflow-x-auto border-b border-slate-200 pb-px lg:flex-wrap`} style={{ WebkitOverflowScrolling: "touch" }}>
      {ongletsVisibles.map((o) =>
        o.cle === ongletActif ? (
          <span
            key={o.cle}
            className="-mb-px shrink-0 whitespace-nowrap border-b-2 border-indigo-600 px-3 py-2 text-sm font-semibold text-indigo-600 sm:px-4"
          >
            {o.libelle}
          </span>
        ) : (
          <Link
            key={o.cle}
            to={`/dashboard/projects/${projectId}${o.chemin}`}
            className="shrink-0 whitespace-nowrap px-3 py-2 text-sm font-medium text-slate-500 hover:text-indigo-600 sm:px-4"
          >
            {o.libelle}
          </Link>
        )
      )}
    </div>
    {modeIA && (
      <div className="mb-4 flex flex-wrap items-center gap-3">
        <div className="inline-flex rounded-xl border border-slate-200 bg-slate-100 p-1">
          {modes.map((m) => m.cle === actif ? (
            <span key={m.cle} className="rounded-lg bg-white px-4 py-1.5 text-sm font-semibold text-indigo-700 shadow-sm">{m.libelle}</span>
          ) : (
            <Link key={m.cle} to={`/dashboard/projects/${projectId}${m.chemin}`}
              className="rounded-lg px-4 py-1.5 text-sm font-medium text-slate-500 hover:text-indigo-600">{m.libelle}</Link>
          ))}
        </div>
        <span className="text-xs text-slate-500">{modeIA.aide}</span>
      </div>
    )}
    </>
  );
}
